// src/tokenService.js
import axios from './axios';
import { useAuthStore } from './stores/auth';
import { showToast } from '@/eventBus.js';

export async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) return null;

    const response = await axios.post('/auth/refresh', {
      refreshToken
    });

    const newAccessToken = response.data.accessToken;
    const auth = useAuthStore();
    auth.loginWithToken(newAccessToken);

    return newAccessToken;
  } catch (err) {
    showToast(err.response.data.message);
    return null;
  }
}

